import { render } from "./NotificationsTable.vue?vue&type=template&id=e77b8b3e&scoped=true"
import script from "./NotificationsTable.vue?vue&type=script&lang=js"
export * from "./NotificationsTable.vue?vue&type=script&lang=js"

import "./NotificationsTable.vue?vue&type=style&index=0&id=e77b8b3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77b8b3e"]])

export default __exports__